module.exports = __webpack_public_path__ + "img/Guinea Bissau.7d29867d.svg";